<template>
  <el-table-column
    prop="close_report_deadline_date"
    sortable="custom"
    label="Záró jegyzőkönyv határideje"
    show-overflow-tooltip
    min-width="240"
  >
    <template slot-scope="scope">
      {{ scope.row.close_report_deadline_date | dateTime }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'close_report_deadline_date',
  };
</script>
